import { SVGProps } from 'react';

export const LightningBolt = ( props: SVGProps<SVGSVGElement> ) => (
	<svg viewBox='0 0 24 24' { ...props }>
		<path
			d='M13.25 2 8.5 12.5h4l-1.25 9.5 4.75-9.5h-4L13.25 2Z'
			fill='none'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
